import Vue from 'vue'
import VueWow from 'vue-wow'

Vue.use(VueWow)